import { createSelector } from '@ngrx/store';
import { selectOperationByCardNumber } from 'src/store/entityStores/shared-selectors';
import { selectAllEstimatedDurations } from './entity-store-selectors';
import { selectCurrentOrNextTripLegByCardNumber_DEPRECATED } from './tripleg-selectors';
import { selectCurrentWaypointForVehicleByCardNumber } from './waypoint-selectors';

export function selectEstimatedDurationsById(id: string) {
  return createSelector(selectAllEstimatedDurations, (durations) => {
    return durations.get(id);
  });
}

export function selectEstimatedDurationsByTripId(tripId: string) {
  return createSelector(selectAllEstimatedDurations, (durations) => {
    return durations.filter((duration) => duration.tripId === tripId);
  });
}

export function selectCurrentEstimatedDurationByCardNumber(cardNumber: string) {
  return createSelector(
    selectOperationByCardNumber(cardNumber),
    selectCurrentWaypointForVehicleByCardNumber(cardNumber),
    selectCurrentOrNextTripLegByCardNumber_DEPRECATED(cardNumber),
    selectAllEstimatedDurations,
    (operation, waypoint, tripLeg, durations) => {
      // when trip is complete, tripleg should be null
      const durationId =
        tripLeg == null || waypoint == null || waypoint.estimatedDurationId == null
          ? undefined
          : waypoint.estimatedDurationId.toLowerCase();
      const unitActivated = operation != null && operation.unitActivationTime != null;

      return durationId == null || !unitActivated
        ? undefined
        : durations.find((d) => d.id === durationId);
    },
  );
}
